import React, { FC, HTMLAttributes } from 'react';
import { Fieldset, Radiogroup } from 'components/forms';
import { ISelectFieldsConfig } from 'constants/eventOptions';
import { ISelectFieldsValues } from './SelectFields';

export interface IFieldType {
  name: string;
  types: string[];
}

export interface IFieldgroups extends HTMLAttributes<HTMLDivElement> {
  name: string;
  disabled?: boolean;
  values: ISelectFieldsValues[];
  config: ISelectFieldsConfig;
  isRemoveEnabled?: boolean;
  onFieldRemove: (name: string) => void;
  checkDisabled?: (type: string, values: string[]) => boolean;
}

const Fieldgroups: FC<IFieldgroups> = (props) => {
  const {
    values,
    name,
    className,
    onFieldRemove,
    isRemoveEnabled,
    checkDisabled = () => false,
    config,
    disabled,
  } = props;
  const hasDeleteButton = isRemoveEnabled ?? values.length > 1;
  if (!Array.isArray(values)) return null;

  return (
    <div className={className}>
      {values.map((value, valueIdx) => (
        <Fieldset
          title={value.name}
          key={value.name}
          disabled={disabled}
          onRemove={hasDeleteButton ? onFieldRemove : () => null}
          className='mt-2'
          hideRemoveButton={!hasDeleteButton}
        >
          {config[value.name]?.map((type, typeIdx) => (
            <Radiogroup
              title={type}
              name={`${name}[${valueIdx}].types[${typeIdx}]`}
              radios={[
                { label: 'global.no', value: '' },
                { label: 'global.yes', value: type },
              ]}
              disabled={disabled ?? checkDisabled(type, value.types)}
              key={type}
            />
          ))}
        </Fieldset>
      ))}
    </div>
  );
};

export default Fieldgroups;
